import { PictogramName } from '../../components/common/Pictogram';
import { ThemeColor } from '../../theme/theme';
import { EventType } from '../../types/events';

export const EVENT_PAGE_QUERY_PARAM = 'eventPage';

export const getPictogramForEventType = (eventType: EventType): PictogramName => {
  switch (eventType) {
    case EventType.CommunityMeeting:
      return 'meeting';
    case EventType.Party:
      return 'party';
    case EventType.CommunityWorkDay:
      return 'gloves';
    case EventType.OtherEvent:
      return 'clubRoom';
  }
};
export const getBackgroundForEventType = (eventType: EventType): ThemeColor => {
  switch (eventType) {
    case EventType.CommunityMeeting:
      return 'apila';
    case EventType.CommunityWorkDay:
      return 'strawberry';
    case EventType.Party:
      return 'mint';
    case EventType.OtherEvent:
      return 'lemon';
  }
};
